<!-- Main Form -->
<div class="form-card">
  <h2>Στοιχεία Επικοινωνίας</h2>
  
  <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmit()" *ngIf="!isSubmitting && !isSuccess">
    <div class="form-row">
      <label for="name">{{ 'NAME' | translate }} *</label>
      <div class="input-group">
        <input 
          id="name" 
          type="text" 
          formControlName="name" 
          placeholder="{{ 'NAME' | translate }}"
          (keydown)="onKeyDownLettersOnly($event)"
          (input)="convertToUppercase($event, 'name')">
        <small *ngIf="formControls['name'].touched && formControls['name'].invalid" class="error">
          {{formControls['name'].errors?.['required'] ? ('REQUIRED' | translate) : 
            formControls['name'].errors?.['pattern'] ? ('ONLY_LETTERS' | translate) : ''}}
        </small>
      </div>
    </div>

    <div class="form-row">
      <label for="surname">{{ 'SURNAME' | translate }} *</label>
      <div class="input-group">
        <input 
          id="surname" 
          type="text" 
          formControlName="surname" 
          placeholder="{{ 'SURNAME' | translate }}"
          (keydown)="onKeyDownLettersOnly($event)"
          (input)="convertToUppercase($event, 'surname')">
        <small *ngIf="formControls['surname'].touched && formControls['surname'].invalid" class="error">
          {{formControls['surname'].errors?.['required'] ? ('REQUIRED' | translate) : 
            formControls['surname'].errors?.['pattern'] ? ('ONLY_LETTERS' | translate) : ''}}
        </small>
      </div>
    </div>

    <div class="form-row">
      <label for="email">{{ 'EMAIL' | translate }} *</label>
      <div class="input-group">
        <input 
          id="email" 
          type="email" 
          formControlName="email" 
          placeholder="{{ 'EMAIL' | translate }}">
        <small *ngIf="formControls['email'].touched && formControls['email'].invalid" class="error">
          {{formControls['email'].errors?.['required'] ? ('REQUIRED' | translate) : 
            formControls['email'].errors?.['email'] ? ('VALID_EMAIL_REQUIRED' | translate) : ''}}
        </small>
      </div>
    </div>

    <div class="form-row">
      <label for="mobileNumber">{{ 'MOBILE_NUMBER' | translate }} *</label>
      <div class="input-group">
        <input 
          id="mobileNumber" 
          type="tel" 
          formControlName="mobileNumber" 
          maxlength="10" 
          placeholder="{{ 'MOBILE_NUMBER' | translate }}"
          (keydown)="onKeyDownDigitsOnly($event)">
        <small *ngIf="formControls['mobileNumber'].touched && formControls['mobileNumber'].invalid" class="error">
          {{formControls['mobileNumber'].errors?.['required'] ? ('REQUIRED' | translate) : 
            formControls['mobileNumber'].errors?.['pattern'] ? ('NUMBERS_ONLY' | translate) : 
            formControls['mobileNumber'].errors?.['maxlength'] ? ('MAX_TEN_DIGITS' | translate) : ''}}
        </small>
      </div>
    </div>

    <!-- Error message if submission failed -->
    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <button type="submit" [disabled]="personalInfoForm.invalid">{{ 'SUBMIT' | translate }}</button>
  </form>

  <!-- Loading Spinner -->
  <div class="spinner-container" *ngIf="isSubmitting">
    <div class="spinner"></div>
    <p>{{ 'SUBMIT' | translate }}..</p>
  </div>

  <!-- Success Modal -->
  <div class="modal-overlay" *ngIf="isSuccess">
    <div class="modal-container animate-modal">
      <div class="modal-content">
        <div class="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#0bcc35" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        <h3>Η αίτηση και τα στοιχεία σας λήφθηκαν με επιτυχία!</h3>
        <button class="close-button" (click)="resetForm()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>